import { render, staticRenderFns } from "./TaskApps.vue?vue&type=template&id=7bd3c1b2&scoped=true&"
import script from "./TaskApps.vue?vue&type=script&lang=js&"
export * from "./TaskApps.vue?vue&type=script&lang=js&"
import style0 from "./TaskApps.vue?vue&type=style&index=0&id=7bd3c1b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd3c1b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VImg } from 'vuetify/lib/components/VImg';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VDivider,VImg,VList})
